import {
  Checkbox,
  FormControlLabel,
  Grid,
  Typography
} from "@mui/material";
import { useState } from "react";
import {
  EmployerForm,
  EmployerFormValuesType
} from "../../components/shared/EmployerForm";
import { LoadingSpinner } from "../../components/shared/LoadingSpinner";
import { UserInfoLogout } from "../../components/shared/UserInfoLogout";
import { useData } from "../../utils/useData";
import { useUpdateEmployer } from "../../hooks/employer/useUpdateEmployer";
import { isLoading } from "../../utils/isLoading";

export const Account = () => {
  const { employer } = useData();
  const [error, setError] = useState("");

  const updateEmployer = useUpdateEmployer({
    onError: (error: Error) => {
      setError(error.message);
    }
  });

  if (isLoading([employer])) return <LoadingSpinner />;

  return (
    <Grid container spacing={5}>
      <Grid item xs={12} md={8}>
        <EmployerForm
          isCreateEmployer={false}
          isLoading={updateEmployer.isLoading}
          employer={employer.data}
          onSubmit={(formValues: EmployerFormValuesType) => {
            updateEmployer.mutate( formValues );
          }}
        >
          {error && (
            <Grid item xs={12}>
              <Typography color="error">{error}</Typography>
            </Grid>
          )}

          {employer.data?.createdAt ? (
            <FormControlLabel
              sx={{ mt: 1 }}
              control={<Checkbox checked={true} disabled={true} />}
              label={
                <span style={{ fontSize: 14 }}>
                  You agreed to our terms and conditions on{" "}
                  {new Date(employer.data?.createdAt).toLocaleDateString(
                    "en-NZ",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "2-digit"
                    }
                  )}
                </span>
              }
            />
          ) : null}
        </EmployerForm>
      </Grid>
      <Grid item xs={4} md={4}>
        <UserInfoLogout hideUserInfo/>
      </Grid>
    </Grid>
  );
};
